import { render, staticRenderFns } from "./ModeratorMailsPage.vue?vue&type=template&id=d185041a&scoped=true&"
import script from "./ModeratorMailsPage.vue?vue&type=script&lang=js&"
export * from "./ModeratorMailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d185041a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
